import React from "react";
import Heading from "../../components/Heading";
import {useTranslation} from "react-i18next";
import {useIndividualizationContext} from "../../contexts/individualizationContext";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../components/IconButton";
import SelectArticle from "./Progress/SelectArticle";
import UploadTemplates from "./Progress/UploadTemplates";
import DefineAreas from "./Progress/DefineAreas";
import DetermineSurchargeType from "./Progress/DetermineSurchargeType";
import NavButtons from "./Progress/NavButtons";
import ProgressBar from "./Progress/ProgressBar";
import ErrorBar from "./Progress/ErrorBar";


const CreateIndividualization: React.FC = () => {
    const { t } = useTranslation(['individualization'])
    const { currentTab, changeCurrentTab } = useIndividualizationContext()

    return currentTab === 2 ? (
        <div>
            <Heading level={2} classes={'mt-4'}>{t('headings.create')}</Heading>
            <div className={'mb-4'}>
                <IconButton
                    icon={faArrowLeft}
                    color={'black'}
                    onClick={() => changeCurrentTab(1)}
                >
                    {t('common.backToOverview')}
                </IconButton>
            </div>
            <ProgressBar/>
            <ErrorBar/>
            <SelectArticle/>
            <UploadTemplates/>
            <DefineAreas/>
            <DetermineSurchargeType/>
            <NavButtons method={'store'}/>
        </div>
    ) : null
}


export default CreateIndividualization;
